import { render, staticRenderFns } from "./myStudents.vue?vue&type=template&id=2340d258"
import script from "./myStudents.vue?vue&type=script&lang=js"
export * from "./myStudents.vue?vue&type=script&lang=js"
import style0 from "./myStudents.vue?vue&type=style&index=0&id=2340d258&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports